// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"Series__wrapper___3ZcjM","title":"Series__title___9jYrW"};


//////////////////
// WEBPACK FOOTER
// ./application/js/components/Series.css
// module id = 522
// module chunks = 0